import MarkdownContent from "../MarkdownContent";

export default function SchemasSection({ apiSpec }) {
  const schemas = apiSpec.components?.schemas || {};

  return (
    <div>
      <div className="content-header">
        <h1>Data Schemas</h1>
        <p className="subtitle">Object definitions used throughout the API</p>
      </div>

      {Object.entries(schemas).map(([name, schema]) => (
        <div className="card" key={name}>
          <h3 style={{ marginTop: 0 }}>{name}</h3>
          {schema.description && <MarkdownContent content={schema.description} />}

          {schema.properties && (
            <table className="params-table">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Type</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(schema.properties).map(([propName, propSchema]) => (
                  <tr key={propName}>
                    <td>
                      <span className="param-name">{propName}</span>
                      {schema.required?.includes(propName) && (
                        <span className="param-required">Required</span>
                      )}
                    </td>
                    <td>
                      <span className="param-type">
                        {propSchema.type || "object"}
                        {propSchema.nullable && " | null"}
                      </span>
                    </td>
                    <td>
                      {propSchema.description ? (
                        <MarkdownContent content={propSchema.description} />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
}
